import { Box, TextField } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { DeckMappDialog } from '../../../../components/DeckMappDialog'

export const KitQuantityDialog = ({ kit, onClose, onSubmit }) => {
  const {
    control,
    handleSubmit,
    formState: { isValid }
  } = useForm({
    defaultValues: {
      quantity: 1
    },
    mode: 'onChange'
  })

  return (
    <DeckMappDialog
      open
      subtitle={`How many units of ${kit.MaterialNumber}${
        kit.MaterialDescription ? ' - ' + kit.MaterialDescription : ''
      } need replacement?`}
      title="Enter Kit Quantity"
      onCancel={onClose}
      saveButtonProps={{
        negativeButtonTitle: 'Cancel',
        title: 'Save',
        form: 'kit-quantity-form',
        type: 'submit',
        disabled: !isValid
      }}>
      <form
        id="kit-quantity-form"
        onSubmit={handleSubmit((data) => {
          onSubmit(data.quantity)
        })}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1em', justifyContent: 'center', py: 2 }}>
          <Controller
            control={control}
            name="quantity"
            rules={{
              required: 'Quantity is required',
              validate: (value) => {
                const num = Number(value)
                if (Number.isNaN(num)) return 'Must be a number'
                if (num <= 0) return 'Quantity must be greater than 0'
                const max = kit.Quantity
                if (max != null && num > Number(max)) {
                  return `Must be less than or equal to available quantity (${max})`
                }
                return true
              }
            }}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Quantity"
                placeholder="e.g. 10"
                color="secondary"
                type="number"
                InputLabelProps={{ shrink: true }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                fullWidth
                autoFocus
                inputProps={{ min: 1 }}
              />
            )}
          />
        </Box>
      </form>
    </DeckMappDialog>
  )
}
